import React from "react";
import CarouselItem from "./carousel_item";
import { getTitle, getReleaseYear, getMediaType } from "../services/tmdb";

// Genre ID to name mapping (TMDB common genres)
const GENRE_MAP = {
  28: "Action", 12: "Adventure", 16: "Animation", 35: "Comedy", 80: "Crime",
  99: "Documentary", 18: "Drama", 10751: "Family", 14: "Fantasy", 36: "History",
  27: "Horror", 10402: "Music", 9648: "Mystery", 10749: "Romance", 878: "Sci-Fi",
  10770: "TV Movie", 53: "Thriller", 10752: "War", 37: "Western",
  10759: "Action & Adventure", 10762: "Kids", 10763: "News", 10764: "Reality",
  10765: "Sci-Fi & Fantasy", 10766: "Soap", 10767: "Talk", 10768: "War & Politics",
};

function Header({ items }) {
  if (!items || items.length === 0) {
    return (
      <div className="container-fluid header-container p-0 mb-5">
        <div style={{ height: "400px" }} className="d-flex align-items-center justify-content-center">
          <div className="skeleton-loader w-100 h-100"></div>
        </div>
      </div>
    );
  }

  const heroItems = items.slice(0, 6);

  return (
    <div className="container-fluid header-container p-0 mb-5">
      <div
        id="carouselExampleFade"
        className="carousel slide carousel-fade"
        data-bs-ride="carousel"
      >
        <div className="carousel-inner">
          {heroItems.map((item, index) => {
            const genreNames = item.genre_ids
              ? item.genre_ids.slice(0, 2).map(id => GENRE_MAP[id] || "").filter(Boolean).join(", ")
              : (item.genres ? item.genres.slice(0, 2).map(g => g.name).join(", ") : "");

            return (
              <CarouselItem
                key={item.id}
                id={item.id}
                active={index === 0}
                mediaType={getMediaType(item)}
                backdropPath={item.backdrop_path}
                posterPath={item.poster_path}
                title={getTitle(item)}
                overview={item.overview || ""}
                rating={item.vote_average}
                voteCount={item.vote_count}
                year={getReleaseYear(item)}
                genres={genreNames}
              />
            );
          })}
        </div>
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleFade"
          data-bs-slide="prev"
          style={{ width: "50px", zIndex: 5 }}
        >
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleFade"
          data-bs-slide="next"
          style={{ width: "50px", zIndex: 5 }}
        >
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  );
}

export default Header;
